"use client";

import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const RequestEntryLayoutChromeContext = createContext({
  suppressChrome: false,
  setSuppressChrome: () => {},
});

export function RequestEntryLayoutChromeProvider({ children }) {
  const [suppressChrome, setSuppressChromeState] = useState(false);
  const setSuppressChrome = useCallback((value) => {
    setSuppressChromeState(Boolean(value));
  }, []);
  const value = useMemo(
    () => ({ suppressChrome, setSuppressChrome }),
    [suppressChrome, setSuppressChrome],
  );
  return (
    <RequestEntryLayoutChromeContext.Provider value={value}>{children}</RequestEntryLayoutChromeContext.Provider>
  );
}

export function useRequestEntryLayoutChrome() {
  return useContext(RequestEntryLayoutChromeContext);
}
